import * as actionTypes from "./actionTypes";

const initialState = {
  isLoadingBasicElements: false,
  isLoading: false,
  entryStructures: [],
  societyPeople: [],
  colaborators: [],
  dateFormat: "dd/mm/yyyy",
  currencyLocalization: "da",
  informedValueTypeTypes: [],
  columnTypes: [],
  rows: [],
  selects: {},
  structureConcepts: {},
  concepts: [],
  conceptsTypes: [],
  quantityPerUsedEntryStructure: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.RESET_STATE:
      return initialState;
    case actionTypes.GET_BASIC_ELEMENTS:
      return { ...state, isLoadingBasicElements: true };
    case actionTypes.GET_BASIC_ELEMENTS_FULFILLED:
      return {
        ...state,
        isLoadingBasicElements: false,
        entryStructures: action.payload.entryStructures,
        currencyLocalization: action.payload.currency_localization,
        dateFormat: action.payload.date_format,
        columnTypes: action.payload.columnTypes,
        informedValueTypeTypes: action.payload.informedValueTypeTypes,
        quantityPerUsedEntryStructure: action.payload.quantityPerUsedEntryStructure,
        decimals: action.payload.decimals,
      };
    case actionTypes.GET_BASIC_ELEMENTS_REJECTED:
      return { ...state, isLoadingBasicElements: false };

    case actionTypes.GET:
      return { ...state, isLoading: true };
    case actionTypes.GET_FULFILLED:
      return {
        ...state,
        isLoading: false,
        rows: action.payload.rows,
        concepts: action.payload.concepts,
        conceptsTypes: action.payload.conceptsTypes,
        selects: action.payload.selects,
        quantityPerUsedEntryStructure: action.payload.quantityPerUsedEntryStructure,
        structureConcepts: action.payload.structureConcepts,
      };
    case actionTypes.GET_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GET_MYPEOPLE_GRID:
      return { ...state, isLoading: true };
    case actionTypes.GET_MYPEOPLE_GRID_FULFILLED:
      return {
        ...state,
        isLoading: false,
        colaborators: action.payload.colaborators,
        societyPeople: action.payload.colaborators.map(el => ({ key: el["CODIGO DE EMPLEADO"], name: el["APELLIDO Y NOMBRE"], "HORAS DIARIAS CONTRATO": el["HORAS DIARIAS CONTRATO"], FOTOGRAFIA: el["FOTOGRAFIA"] }))
      };
    case actionTypes.GET_MYPEOPLE_GRID_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.CREATE:
      return { ...state, isLoading: true };
    case actionTypes.CREATE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        rows: action.payload.rows,
        quantityPerUsedEntryStructure: action.payload.quantityPerUsedEntryStructure,
      };
    case actionTypes.CREATE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.MODIFY:
      return { ...state, isLoading: true };
    case actionTypes.MODIFY_FULFILLED:
      return {
        ...state,
        isLoading: false,
        rows: action.payload.rows,
        quantityPerUsedEntryStructure: action.payload.quantityPerUsedEntryStructure,
      };
    case actionTypes.MODIFY_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DELETE:
      return { ...state, isLoading: true };
    case actionTypes.DELETE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        rows: action.payload.rows,
        quantityPerUsedEntryStructure: action.payload.quantityPerUsedEntryStructure,
      };
    case actionTypes.DELETE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DOWNLOAD:
      return { ...state, isLoading: true };
    case actionTypes.DOWNLOAD_FULFILLED:
      return { ...state, isLoading: false };
    case actionTypes.DOWNLOAD_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.ADD_CONCEPT:
      return { ...state, isLoading: true };
    case actionTypes.ADD_CONCEPT_FULFILLED:
      return {
        ...state,
        isLoading: false,
        structureConcepts: action.payload.structureConcepts,
      };
    case actionTypes.ADD_CONCEPT_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DUPLICATE_CONCEPT:
      return { ...state, isLoading: true };
    case actionTypes.DUPLICATE_CONCEPT_FULFILLED:
      return {
        ...state,
        isLoading: false,
        structureConcepts: action.payload.structureConcepts,
      };
    case actionTypes.DUPLICATE_CONCEPT_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DUPLICATE:
      return { ...state, isLoading: true };
    case actionTypes.DUPLICATE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        rows: action.payload.rows,
        quantityPerUsedEntryStructure: action.payload.quantityPerUsedEntryStructure,
      };
    case actionTypes.DUPLICATE_REJECTED:
      return { ...state, isLoading: false };
    default:
      return state;
  }
}
